export default "__VITE_ASSET__CC3aH1bK__"